import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Oh shit",
  "description": "",
  "published": "2006-11-07T00:00:00.000Z",
  "redirect_from": ["/blog/oh-shit/swizec/368"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday was an all over bad day it would seem, I was preoccupied with sleeping in front of the telly to write this blog and in hopes of such a coincidentiality being avoided today I'm writing as early as 1700 ... as if that was super early, but hey, all is well if the blog is done right?`}</p>
    <p>{`Sadly, no. Due to some thing or another I haven't managed to write even a thousand words all since Friday and yeah, you guessed it, that's really bad, I'm too daunted by the fact to even calculate just how much behind schedule I am, it's that scary. In all factuality I believe that fussing about wordcount at this moment would cause too much "omg" to provide a good working atmosphere, so I'll rather focus on writing as much as is possible and hope for the best.`}</p>
    <p>{`On the other hand ... I did manage to write a whooping 300 words at school today, which acciedentally also happens to be the complete wordcount of today so far.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      